import script from "./CartDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CartDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CartDrawer.vue?vue&type=style&index=0&id=464baca0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464baca0"]])

export default __exports__